
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"60","height":"60","fill":"none","viewBox":"0 0 60 60"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"stroke":"currentColor","stroke-linecap":"round","stroke-linejoin":"round","stroke-width":"2","d":"M52.74 9.818c-1.14-1.85-1.52-2.33-1.99-2.8-2.04-.09-4.7 0-8.4 3.89-4.37-1.42-6.88-2.18-10.77.33-3.89 2.52-3.65 6.88-3.7 7.59-.05.71-.71 3.27-3.56 4.18-2.85.9-4.65 2.89-5.69 9.3-2.37.81-5.55 1.52-6.74 5.84-1.19 4.32-.19 6.03-3.89 12.48 5.17.09 8.4 2.14 12.91 1.9 4.51-.24 8.02-4.75 8.59-8.26 4.18-1.8 5.98-3.75 6.93-5.17.95-1.42 1.38-3.8 1.42-4.65.04-.85-.19-3.18 2.89-4.27 3.08-1.09 5.46-6.22 5.55-8.4.09-2.18-.62-5.98-.57-6.6.05-.62 1.61-4.08 7.02-5.36v0z"}}),_c('path',{attrs:{"stroke":"currentColor","stroke-linecap":"round","stroke-linejoin":"round","stroke-width":"2","d":"M36.32 25.338a4.75 4.75 0 100-9.5 4.75 4.75 0 000 9.5zm-8.56 11.74a4.75 4.75 0 100-9.5 4.75 4.75 0 000 9.5zm-8.6 10.61a4.75 4.75 0 100-9.5 4.75 4.75 0 000 9.5z"}})])
          )
        }
      }
    